export class InvoiceFilter {
  public fromDate: string;
  public toDate: string;
  public offset: number;
  public limit: number;
}
